/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
  text?: string;
};

export const ExtendTrialButton = ({ onClick, text = 'Start trial' }: Props) => (
  <Button color="secondary" onClick={onClick}>
    {text}
  </Button>
);
